import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';
import { NotificationBadge } from 'src/type/notification';

export type BadgeState = {
  notification: NotificationBadge;
  transaction: {
    topup: number;
    withdraw: number;
    redeem: number;
    position: number;
    topupDeposit: number;
    deposit: number;
    almostExpired: number;
  };
};

const initialState: BadgeState = {
  notification: {
    readCount: 0,
    totalCount: 0,
    unReadCount: 0,
    updatedAt: 0,
  },
  transaction: {
    redeem: 0,
    topup: 0,
    withdraw: 0,
    position: 0,
    topupDeposit: 0,
    deposit: 0,
    almostExpired: 0,
  },
};

const slice = createSlice({
  name: 'badge',
  initialState,
  reducers: {
    setNotificationBadgeAction: (state, action: PayloadAction<NotificationBadge>) => {
      state.notification = {
        readCount: action.payload?.readCount || 0,
        totalCount: action.payload?.totalCount || 0,
        unReadCount: action.payload?.unReadCount || 0,
        updatedAt: action.payload?.updatedAt || 0,
      };
    },
    setTransactionBadgeAction: (
      state,
      action: PayloadAction<{
        redeem: number;
        topup: number;
        withdraw: number;
        position: number;
        topupDeposit: number;
        deposit: number;
        almostExpired: number;
      }>
    ) => {
      state.transaction = action.payload;
    },
  },
});

export const { setNotificationBadgeAction, setTransactionBadgeAction } = slice.actions;

export default slice.reducer;
